import { JSONParser } from '../../functions/Helper';
import * as types from "../actions/ActionTypes";
import { EndUserFormInitial } from "../store/InitialStore";

const parseCategory = (categoryDetails) => {
  let categories = JSONParser(categoryDetails, [])
  return categories.map(e => ({ ...e, categoryPlaceHolder: JSONParser(e.categoryPlaceHolder, []) }))
}

export default function customerFormReducer(state = EndUserFormInitial, action) {
  const { type, payload } = action;
  switch (type) {

    
    case types.CUSTOMER_CATEGORY_NAVIGATION:
      if(payload === 'NEXT'){
        
      }
      return {
        ...state
      }
    case types.END_USER_DETAILS_SUCCESS:
      return {
        planName: payload.planName,
        planDescription: payload.planDescription,
        planDuration: payload.planDuration,
        activeCategory: JSONParser(payload.categoryId, [])[0] || null,
        licenseRequiredDocDetails: JSONParser(payload.licenseRequiredDocDetails, []),
        categoryId: JSONParser(payload.categoryId, []),
        categoryDetails: parseCategory(payload.categoryDetails),
        form: payload,
        error: false
      };

    case types.END_USER_DETAILS_ERROR:
      return { ...EndUserFormInitial, error: true }
    default:
      return state;
  }
}

